import axios from 'axios'

export default class Porte {
  constructor (tokenBearer, url) {
    this.url = `${url}/api/dominios/porte`
    this.tokenBearer = tokenBearer
  }

  getPortes () {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: this.url,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }
}
